import bus from '../utils/bus';

/* types => "success" | "error" | "info" | "warning" | "secondary" */

export const flash = {
    success(message, tempo = 3, position = 'center') {
        bus.emit('flash', {
            msgText: message,
            msgType: 'success',
            msgTempo: tempo,
            msgPosition: position,
        });
    },

    info(message, tempo = 3, position = 'center') {
        bus.emit('flash', {
            msgText: message,
            msgType: 'info',
            msgTempo: tempo,
            msgPosition: position,
        });
    },

    warning(message, tempo = 3, position = 'center') {
        bus.emit('flash', {
            msgText: message,
            msgType: 'warning',
            msgTempo: tempo,
            msgPosition: position,
        });
    },

    error(message, tempo = 3, position = 'center') {
        bus.emit('flash', {
            msgText: message,
            msgType: 'error',
            msgTempo: tempo,
            msgPosition: position,
        });
    },
};
